/**
 * Container.js
 *
 * Copyright (c) apploft. GmbH
 */

import React, {useReducer, useEffect} from 'react';
import Content from './EndPoint/Content';
import {reducer, init} from './EndPoint/ContentState';
import NavigationBar from './NavigationBar';
import {selectSection} from './EndPoint/ContentEventSymbol';

function Container({section, api, strings}) {
  const [store, dispatch] = useReducer(reducer, api, init);

  useEffect(() => {
    dispatch({event: selectSection, payload: {section, api, dispatch}});
  }, [api, section]);

  return (
    <div className="stage">
      <div className="endpointBrowserContainer">
        <NavigationBar
          state={store.state}
          data={store.data}
          dispatch={dispatch}
          strings={strings}
        />
        <Content
          state={store.state}
          data={store.data}
          dispatch={dispatch}
          strings={strings}
        />
      </div>
    </div>
  );
}

export default Container;
